import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import { isMobile } from 'react-device-detect'

import { Button, IconInline } from '@omnilert/components'
import useStyles from './modal.style'

const Modal = (props) => {
  const { children, cornerButton, isVisible, onClose, className } = props

  const classes = useStyles({ isMobile })

  const getClasses = useMemo(() => {
    const modalClasses = [classes.modalContainer, classes.fadeIn, { [className]: !!className }]

    return classNames(modalClasses)
  }, [classes.modalContainer, className, classes.fadeIn])

  if (!isVisible) return null

  return (
    <div className={getClasses}>
      {cornerButton && (
        <div className={classes.buttonContainer}>
          <Button
            className={classes.cornerButton}
            icon={
              <IconInline
                className={classes.closeIcon}
                name='close'
                size={18}
              />
            }
            onClick={onClose}
            variant='transparent'
          />
        </div>
      )}
      <div className={classes.modalContent}>{children}</div>
    </div>
  )
}

Modal.defaultProps = {
  children: null,
  className: '',
  cornerButton: false,
  isVisible: false
}

Modal.propTypes = {
  className: PropTypes.string,
  cornerButton: PropTypes.bool,
  children: PropTypes.node,
  isVisible: PropTypes.bool
}

export default Modal
